import React from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  CAR_CHOICE_ACCEPTED,
  CAR_CHOICE_ACCEPTED_WITH_REPRICE,
  CARS_BOOKED_NOT_INTERESTED,
} from 'lib/carChoicesLib'

import CarCardAdditionalDetails from 'components/atoms/CarCardAdditionalDetails'
import CarCardAdditionalDetailsItem from 'components/atoms/CarCardAdditionalDetailsItem'

import { getCarsBookedStatusColor } from './carsBookedLib'

export default function CarBookedCarAdditionalDetails({ vertical, car }) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')

  return (
    <CarCardAdditionalDetails
      vertical={vertical}
      data-testid="car-booked-additional-details"
    >
      {!vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.status')}
          value={t(`carsBooked.status.${car.assignedState}`)}
          valueProps={{
            color: getCarsBookedStatusColor(car.assignedState),
          }}
        />
      )}

      <CarCardAdditionalDetailsItem
        vertical={vertical}
        title={t('carsBooked.additionalTitles.choice')}
        value={t(
          `carsBooked.${
            car.choice === CAR_CHOICE_ACCEPTED
              ? CAR_CHOICE_ACCEPTED
              : car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE
              ? CAR_CHOICE_ACCEPTED_WITH_REPRICE
              : CARS_BOOKED_NOT_INTERESTED
          }`
        )}
      />

      {vertical && car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.originalPrice')}
          value={`€ ${numberFormatter.format(car.price + car.fee)}`}
        />
      )}
      <CarCardAdditionalDetailsItem
        vertical={vertical}
        title={
          car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE
            ? t('carsBooked.additionalTitles.reprice')
            : t('carsBooked.additionalTitles.original')
        }
        value={`${vertical ? '€ ' : ''}${numberFormatter.format(
          car.choice === CAR_CHOICE_ACCEPTED_WITH_REPRICE
            ? car.reprice
            : car.price + car.fee
        )}`}
      />

      {vertical && <Box p={1} />}
      {vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.status')}
          value={t(`carsBooked.status.${car.assignedState}`)}
          valueProps={{
            color: getCarsBookedStatusColor(car.assignedState),
          }}
        />
      )}
    </CarCardAdditionalDetails>
  )
}

CarBookedCarAdditionalDetails.propTypes = {
  vertical: T.bool,
  car: T.object.isRequired,
}
